import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subject } from "rxjs";
import { switchMap, takeUntil } from "rxjs/operators";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { PlanyardService } from "src/app/modules/planyard/planyard.service";
import { SnackbarComponent } from '../../../../components/snackbar/snackbar.component';
declare var google;

@Component({
  selector: "app-add-vendor-dialog",
  templateUrl: "./add-vendor-dialog.component.html",
  styleUrls: ["./add-vendor-dialog.component.scss"],
})
export class AddVendorDialogComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  form: FormGroup = new FormGroup({
    name: new FormControl("", Validators.required),
    address1: new FormControl(""),
    phone: new FormControl(""),
    email: new FormControl(""),
    leadDays: new FormControl(),
    purchaseDays: new FormControl(60),
    safetyStock: new FormControl(),
    OrderMinimumAmount: new FormControl(),
    terms: new FormControl()
  });
  spin: boolean =false;
  private destroy$ = new Subject<void>();
  address: { [key: string]: string };
  addressTypes = [
    { key: "address1", type: "street_number" },
    { key: "address1", type: "route" },
    { key: "address1", type: "neighborhood" },
    { key: "address2", type: "sublocality_level_2" },
    { key: "address2", type: "sublocality_level_1" },
    { key: "address2", type: "locality" },
    { key: "city", type: "administrative_area_level_2" },
    { key: "state", type: "administrative_area_level_1" },
    { key: "postal", type: "postal_code" },
    { key: "country", type: "country" },
  ];

  @ViewChild("addressText") addressText: any;
  constructor(
    private planyardService: PlanyardService,
    public dialogRef: MatDialogRef<AddVendorDialogComponent>,
    private gridActionsService: GridActionsService,
    @Inject(MAT_DIALOG_DATA) public dialogData,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    const nameInput = this.form.get("name");
    nameInput.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        switchMap((e) => this.planyardService.VendorExists(e))
      )
      .subscribe((e) => {
        if (e) {
          if (
            !this.dialogData ||
            this.dialogData.VendorName !== nameInput.value
          ) {
            nameInput.setErrors({ unique: true });
          }
        } else {
          nameInput.setErrors(null);
        }
      });
    if (this.dialogData) {
      this.form.addControl(
        "id",
        new FormControl(this.dialogData.VendorId, Validators.required)
      );
      this.form.patchValue({
        name: this.dialogData.VendorName,
        address1: this.dialogData.Address1,
        phone: this.dialogData.Phone,
        email: this.dialogData.Email,
        leadDays: this.dialogData.LeadDays,
        purchaseDays: this.dialogData.PurchaseDays,
        safetyStock: this.dialogData.SafetyStock,
        OrderMinimumAmount: this.dialogData.OrderMinimumAmount
      });
      this.address = {
        address1: this.dialogData.Address1,
        address2: this.dialogData.Address2,
        city: this.dialogData.City,
        state: this.dialogData.State,
        postal: this.dialogData.Postal,
        country: this.dialogData.Country,
      };
    }
    this.form.get("phone").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      if (value) {
        const x = value.replace(/\D/g, "");
        if (x && x.length < 10) {
          this.form.controls["phone"].setErrors({ incorrect: true });
        } else {
          this.form.controls["phone"].setErrors(null);
        }
      }
    });
    this.form.get("address1").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      if (!value) {
        this.resetAddressData();
      }
    });
  }

  ngAfterViewInit(): void {
    this.getPlaceAutocomplete();
  }

  getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(
      this.addressText.nativeElement,
      { types: ["address"] }
    );
    google.maps.event.addListener(autocomplete, "place_changed", () => {
      const place = autocomplete.getPlace();
      this.setAddressData(place);
    });
  }

resetAddressData(): void {
    this.address = {
      address1: "",
      address2: "",
      city: "",
      state: "",
      postal: "",
      country: "",
    };
  }

  setAddressData(place): void {
    this.resetAddressData();
    this.addressTypes.forEach((res) => {
      const data = place.address_components.find((address) =>
        address.types.includes(res.type)
      )?.long_name;
      if (data)
        this.address[res.key] = (this.address[res.key] + " " + data).trim();
    });
  }

  save() {
    this.form.value.name = this.form.value.name.trim();
    let payload = this.form.value;
    payload = { ...payload, ...this.address };
    this.planyardService.SaveVendor(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: `Vendor ` + (this.dialogData ? 'updated' : 'added') + ` successfully`,
              action: 'Dismiss',
              type: 'success',
            },
          }
      );
      this.spin = false;
      this.gridActionsService.refresh();
      this.dialogRef.close();
    },
     error: (err) => {
      this.spin = false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: `Something went wrong`,
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
    });
  }

  action(e?) {
    if (e === "Save") {
      this.spin = true;
      this.save();
    } else {
      this.dialogRef.close();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
